import { AppCard } from '@/layout/AppComponents';

export default function EnvironmentalAspectsAssessmentAspectTitleCard({
  color,
  className,
  children,
}) {
  return (
    <AppCard
      className={`alert alert-${color}${className ? ` ${className}` : ''}`}
    >
      {children}
    </AppCard>
  );
}
